<template lang="pug">
div(
  class='lg:bg-gray-lighter [&_img]:inline-block [&_svg]:inline-block'
  :class='rootStore.isSimpleMode ? "bg-gray-lighter" : "bg-white"'
)
  div(class='p-3 lg:container')
    template(v-if='isLoading')
      div(v-if='!cartStore.cart.id' class='py-10')
        SpinnerText(text='Cart Loading' is-dark)

    template(v-else)
      ul(
        v-if='$route.name !== "checkout-receipt"'
        class='flex justify-between mt-2 text-gray text-sm whitespace-nowrap font-bold sm:text-lg md:text-xl lg:justify-start lg:gap-x-10 lg:mt-8 lg:mb-12'
      )
        li(class='or-checkout-step-active hover:underline')
          UniversalLink(link='/checkout/cart/' class='flex items-center')
            span(class='or-checkout-step-box bg-gray text-light w-6 mr-2 rounded text-center leading-6') 1
            | Cart

        li(:class='{ "or-checkout-step-active hover:underline": $route.name !== "checkout-cart" }')
          UniversalLink(:link='$route.name === "checkout-payment" ? "/checkout/address/" : ""' class='flex items-center')
            span(class='or-checkout-step-box bg-gray text-light w-6 mr-2 rounded text-center leading-6') 2
            | Address

        li(:class='{ "or-checkout-step-active hover:underline": $route.name === "checkout-payment" }')
          div(class='flex items-center')
            span(class='or-checkout-step-box bg-gray text-light w-6 mr-2 rounded text-center leading-6') 3
            | Payment

      p(id='cart' class='my-5 capitalize text-3xl font-bold')
        template(v-if='$route.name === "checkout-cart"')
          span(class='flex flex-col lg:flex-row lg:items-center')
            | Shopping Cart
            span(class='text-xs font-normal lg:border-l lg:ml-3 lg:pl-3') Cart ID: {{ cartStore.cart.shortId }}

        template(v-else-if='$route.name === "checkout-address"') Shipping Address

        template(v-else-if='$route.name === "checkout-payment"')
          template(
            v-if='checkoutStore.checkout.summary.giftCardSubtotal !== 0 && checkoutStore.checkout.summary.grandTotal === 0'
          )
            | Checkout With Gift Card
          template(v-else)
            | Checkout With Credit Card

      template(v-if='cartStore.cart.itemCount === 0 && $route.name !== "checkout-receipt"')
        p(class='pb-6') There are no items in your cart
        div(v-if='isIntegrationEnabled("cognito")')
          Wishlist(empty-cart-mode)
            template(#default)
              div(class='my-4 capitalize text-3xl font-bold')
                | Saved Items

      template(v-if='cartStore.cart.itemCount > 0 || $route.name === "checkout-receipt"')
        div(class='lg:flex lg:justify-between')
          div(class='bg-gray-lighter mb-5' :class='checkoutWrapperClass')
            NuxtPage
            div(
              v-if='checkoutStore.isProcessing'
              aria-labelledby='Processing'
              role='dialog'
              aria-modal='true'
              class='fixed z-50 inset-0 overflow-hidden flex items-center justify-center'
            )
              div(class='absolute w-full h-full bg-black opacity-80')
              SpinnerText(text='Processing...' class='relative')

          div(
            v-if='$route.name !== "checkout-receipt"'
            :class='rootStore.isSimpleMode ? "lg:w-2/5" : "lg:w-[30%] lg:max-w-[400px]"'
          )
            CheckoutSubtotal(id='subtotal')

  div(v-if='$route.name === "checkout-cart" && !$device.value.isDesktop' class='p-3 bg-gray-lighter lg:container')
    CheckoutNeedHelp
</template>

<script setup lang="ts">
const route = useRoute()
const rootStore = useRootStore()
const cartStore = useCartStore()
const checkoutStore = useCheckoutStore()
const { isIntegrationEnabled } = useUtils()
const isLoading = computed(() => !cartStore.cart.id || !checkoutStore.checkout.id)

watch(
  () => cartStore.cart,
  () => checkoutStore.getCheckout()
)

onMounted(() => {
  checkoutStore.getCheckout()
})

onUnmounted(() => {
  rootStore.isSimpleMode = false
})

const checkoutWrapperClass = computed(() => {
  if (route.name === 'checkout-receipt') return 'w-full'
  if (rootStore.isSimpleMode) return 'lg:w-1/2 lg:grow-0'
  return 'lg:w-[67%]'
})
</script>
